const white = 'var(--primitives-color-basic-white)';
const dark = 'var(--primitives-color-gray-1600)';

// Official app.hyperliquid.xyz/coins artwork, visually reviewed 2026-09-29.
// Only contrast-sensitive artwork needs overrides; other illustrations and opaque logos use neutral.
// Key overrides by the full API market coin, including any HIP-3 DEX prefix.
// These fixed brand backgrounds must not flip in dark mode.
const coinIconBackgroundOverrides = new Map<string, string>([
  ['0G', white],
  ['2Z', white],
  ['ADA', white],
  ['ALT', white],
  ['AR', white],
  ['BADGER', white],
  ['BIGTIME', white],
  ['CAKE', white],
  ['CC', white],
  ['CFX', white],
  ['DOT', white],
  ['DYM', white],
  ['ENS', white],
  ['ETC', white],
  ['ETH', white],
  ['ETHFI', white],
  ['GALA', white],
  ['INJ', white],
  ['io:ANTH', white],
  ['kFLOKI', white],
  ['MEGA', white],
  ['NEAR', white],
  ['NIL', white],
  ['OMNI', white],
  ['ONDO', white],
  ['ORBS', white],
  ['PURR', white],
  ['REQ', white],
  ['SEI', white],
  ['STRAX', white],
  ['TRX', white],
  ['UNI', white],
  ['UNIBOT', white],
  ['USTC', white],
  ['VIRTUAL', white],
  ['WLD', white],
  ['XAI', white],
  ['XLM', white],
  ['XRP', white],
  ['xyz:AMZN', white],
  ['ACE', dark],
  ['APEX', dark],
  ['BLAST', dark],
  ['BLZ', dark],
  ['CASHCAT', dark],
  ['CRV', dark],
  ['GAS', dark],
  ['IO', dark],
  ['JUP', dark],
  ['kLUNC', dark],
  ['MANTA', dark],
  ['MNT', dark],
  ['NEO', dark],
  ['NTRN', dark],
  ['PAXG', dark],
  ['PIXEL', dark],
  ['PONS', dark],
  ['RUNE', dark],
  ['S', dark],
  ['SAGA', dark],
  ['SKY', dark],
  ['SOPH', dark],
  ['STABLE', dark],
  ['WLFI', dark],
  ['XPL', dark],
  ['YZY', dark],
  // Official frontend backgrounds: HYPE trade page; FET/ZEN explicit icon mappings.
  ['HYPE', '#04251F'],
  ['FET', '#202944'],
  ['ZEN', '#031841'],
]);

export function getPerpsCoinIconBackgroundColor(coin: string): string {
  return coinIconBackgroundOverrides.get(coin) ?? 'var(--token-color-gray-400)';
}
